module.exports = __webpack_public_path__ + "media/src/images/icons/twitter_logo-4efcc24fb11e7a2f653ed86155a2b1f7.svg";